import { TextField } from '@mui/material';
import React, { useEffect } from 'react';

import { BasicTextFieldProps } from './BasicTextField.types';

function BasicTextField(props: BasicTextFieldProps) {
  const textFieldRef = React.useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    function handleWheel(e: WheelEvent) {
      e.preventDefault();
    }
    const element = textFieldRef.current;
    if (element) {
      element.addEventListener('wheel', handleWheel);

      return () => {
        element.removeEventListener('wheel', handleWheel);
      };
    }
  }, []);
  return (
    <TextField
      hiddenLabel
      variant="outlined"
      size="small"
      {...props}
      ref={textFieldRef}
    />
  );
}
export default BasicTextField;
